import React from "react";
import Table from "../../../../../../common/components/molecule/Table/Table";

export interface ChargingSessionItem {
  id: string;
  createAt?: string;
  kWhAmount?: number | string;
  price?: string | number;
  currency?: string;
  clientRender?: () => JSX.Element;
  stationRender?: () => JSX.Element;
  organisationRender?: () => JSX.Element;
  onClick?: () => void;
}
export interface ChargingSessionViewProps {
  content?: ChargingSessionItem[];
  nbFound?: number;
}
export default function ChargingSessionListView({
  content = [],
  nbFound,
}: ChargingSessionViewProps) {
  return (
    <div>
        
      <Table
        headerTitle={[
          "kWh",
          "Prix",
          "Devise",
          "Client",
          "Station",
          "Oragnisation",
          "Créé le",
        ]}
        bodyData={content.map((item) => {
          return {
            id: item.id,
            onRowClick: item.onClick,
            data: [
              item.kWhAmount || "NA",
              item.price || "NA",
              item.currency || "NA",
              item.clientRender,
              item.stationRender,
              item.organisationRender,
              item.createAt,
            ],
          };
        })}
        emptyMessage="Aucun rechargement trouvé"
        NbFoundViewProps={{
          nbFound: nbFound,
          itemName: {
            single: "rechargement trouvé",
            plurial: "rechargements trouvés",
          },
        }}
      />
    </div>
  );
}
